/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/ban-ts-comment */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { useCallback, useEffect, useState } from "react";
import { InlineEdit } from "../../components/InlineEdit";
import { Button } from "../../components/Button";
import { useParams } from "react-router-dom";
import useSaveTemplate from "../../utils/customHooks";
import { SpinnerOverlay } from "../../utils/SpinnerOverlay";
import getCroppedImg from "../../utils/cropImage";
import { CropperWrapper } from "../../utils/CropperWrapper";
import ImageUploader from "../../utils/ImageUploader";

export const Basnie36: React.FC = () => {
  const { pdfNameFromUrl } = useParams<{ pdfNameFromUrl: string }>();
  const [text1, setText1] = useState<string>("Moja Pierwsza Księga Baśni");
  const [text2, setText2] = useState<string>("Antoś");
  const [text3, setText3] = useState<string>("29.09");
  const [text4, setText4] = useState<string>("2021r.");
  const [text5, setText5] = useState<string>("23:45");
  const [text6, setText6] = useState<string>("3100g");
  const [text7, setText7] = useState<string>("56cm");
  const [text8, setText8] = useState<string>("Dzieci są nadzieją, która rozkwita wciąż na nowo,");
  const [text9, setText9] = useState<string>("projektem, który nieustannie się urzeczywistnia,");
  const [text10, setText10] = useState<string>("przyszłością, która pozostaje zawsze otwarta.");
  const [text11, setText11] = useState<string>("Jan Paweł II");
  const [text12, setText12] = useState<string>("20.11.2021 r.");
  const text1BasicSize = 70;
  const text2BasicSize = 70;
  const text3BasicSize = 36;
  const text4BasicSize = 36;
  const text5BasicSize = 38;
  const text6BasicSize = 36;
  const text7BasicSize = 32;
  const text8BasicSize = 22;
  const text9BasicSize = 22;
  const text10BasicSize = 22;
  const text11BasicSize = 21;
  const text12BasicSize = 36;
  const [fontSizeText1, setFontSizeText1] = useState<number>(text1BasicSize);
  const [fontSizeText2, setFontSizeText2] = useState<number>(text2BasicSize);
  const [fontSizeText3, setFontSizeText3] = useState<number>(text3BasicSize);
  const [fontSizeText4, setFontSizeText4] = useState<number>(text4BasicSize);
  const [fontSizeText5, setFontSizeText5] = useState<number>(text5BasicSize);
  const [fontSizeText6, setFontSizeText6] = useState<number>(text6BasicSize);
  const [fontSizeText7, setFontSizeText7] = useState<number>(text7BasicSize);
  const [fontSizeText8, setFontSizeText8] = useState<number>(text8BasicSize);
  const [fontSizeText9, setFontSizeText9] = useState<number>(text9BasicSize);
  const [fontSizeText10, setFontSizeText10] = useState<number>(text10BasicSize);
  const [fontSizeText11, setFontSizeText11] = useState<number>(text11BasicSize);
  const [fontSizeText12, setFontSizeText12] = useState<number>(text12BasicSize);
  const { saveTemplate, isSaving } = useSaveTemplate();
  const [image, setImage] = useState<string | null>(null);
  const [croppedImage, setCroppedImage] = useState<string | null>(null);
  const [crop, setCrop] = useState<{ x: number; y: number }>({ x: 0, y: 0 });
  const [zoom, setZoom] = useState<number>(1);
  const [croppedAreaPixels, setCroppedAreaPixels] = useState<any>(null);
  const [step, setStep] = useState<"select" | "crop" | "view">("select");

  const pdfWidth = "250mm"; // PDF width in mm
  const pdfHeight = "300mm"; // PDF height in mm
  const maxWidth = 850; // Maximum width for text
  const maxWidth2 = 140;
  const adjustFontSize = (
    text: string,
    currentFontSize: number,
    maxFontSize: number,
    minFontSize: number
  ) => {
    const canvas = document.createElement("canvas");
    const context = canvas.getContext("2d");

    if (context) {
      let newFontSize = currentFontSize;
      context.font = `${newFontSize}px 'Margarine-Regular'`;
      let textWidth = context.measureText(text).width;

      while (textWidth > maxWidth && newFontSize > minFontSize) {
        newFontSize -= 1;
        context.font = `${newFontSize}px 'Margarine-Regular'`;
        textWidth = context.measureText(text).width;
      }

      while (textWidth < maxWidth * 0.9 && newFontSize < maxFontSize) {
        newFontSize += 1;
        context.font = `${newFontSize}px 'Margarine-Regular'`;
        textWidth = context.measureText(text).width;
      }

      return newFontSize;
    }

    return currentFontSize;
  };

  const adjustFontSize2 = (
    text: string,
    currentFontSize: number,
    maxFontSize: number,
    minFontSize: number
  ) => {
    const canvas = document.createElement("canvas");
    const context = canvas.getContext("2d");

    if (context) {
      let newFontSize = currentFontSize;
      context.font = `${newFontSize}px 'Margarine-Regular'`;
      let textWidth = context.measureText(text).width;

      while (textWidth > maxWidth2 && newFontSize > minFontSize) {
        newFontSize -= 1;
        context.font = `${newFontSize}px 'Margarine-Regular'`;
        textWidth = context.measureText(text).width;
      }

      while (textWidth < maxWidth2 * 0.9 && newFontSize < maxFontSize) {
        newFontSize += 1;
        context.font = `${newFontSize}px 'Margarine-Regular'`;
        textWidth = context.measureText(text).width;
      }

      return newFontSize;
    }

    return currentFontSize;
  };

  useEffect(
    () => setFontSizeText1(adjustFontSize(text1, fontSizeText1, text1BasicSize, 12)),
    [text1],
  );
  useEffect(
    () => setFontSizeText2(adjustFontSize(text2, fontSizeText2, text2BasicSize, 18)),
    [text2],
  );
  useEffect(
    () => setFontSizeText3(adjustFontSize2(text3, fontSizeText3, text3BasicSize, 12)),
    [text3],
  );
  useEffect(
    () => setFontSizeText4(adjustFontSize2(text4, fontSizeText4, text4BasicSize, 12)),
    [text4],
  );
  useEffect(
    () => setFontSizeText5(adjustFontSize2(text5, fontSizeText5, text5BasicSize, 12)),
    [text5],
  );
  useEffect(
    () => setFontSizeText6(adjustFontSize2(text6, fontSizeText6, text6BasicSize, 12)),
    [text6],
  );
  useEffect(
    () => setFontSizeText7(adjustFontSize2(text7, fontSizeText7, text7BasicSize, 12)),
    [text7],
  );
  useEffect(
    () => setFontSizeText8(adjustFontSize(text8, fontSizeText8, text8BasicSize, 12)),
    [text8],
  );
  useEffect(
    () => setFontSizeText9(adjustFontSize(text9, fontSizeText9, text9BasicSize, 12)),
    [text9],
  );
  useEffect(
    () => setFontSizeText10(adjustFontSize(text10, fontSizeText10, text10BasicSize, 12)),
    [text8],
  );
  useEffect(
    () => setFontSizeText11(adjustFontSize(text11, fontSizeText11, text11BasicSize, 12)),
    [text8],
  );
  useEffect(
    () => setFontSizeText12(adjustFontSize(text12, fontSizeText12, text12BasicSize, 12)),
    [text8],
  );


  const handleSave = () => {
    saveTemplate(
      "printable-content",
      {
        pdfWidth: pdfWidth,
        pdfHeight: pdfHeight,
        pdfNameFromUrl: pdfNameFromUrl,
      },
      croppedImage,
      true
    );
  };

  const handleCropComplete = useCallback((croppedArea: any, croppedAreaPixels: any) => {
    setCroppedAreaPixels(croppedAreaPixels);
  }, []);

  const handleShowCroppedImage = useCallback(async () => {
    if (image && croppedAreaPixels) {
      // Function to crop the image and get the result
      const croppedImg = await getCroppedImg(image, croppedAreaPixels); // Replace with your image cropping logic
      setCroppedImage(croppedImg);
      setStep("view");
    }
  }, [image, croppedAreaPixels]);

  return (
    <div style={{
      width: "100%",
      height: "100%",
      backgroundColor: "#ffffff", padding: "80px",
      position: "relative",
    }}>
      {/* Spinner Overlay */}
      <SpinnerOverlay isVisible={isSaving} />
      <div style={{ position: "absolute", top: "10px", left: "0px", right: "0px", margin: "auto", color: "white", width: "480px", maxWidth: "100%", height: "70px", gap: "30px", display: "flex", alignItems: "center" }}>
        <ImageUploader
          onImageChange={(image) => setImage(image)}
          setStep={setStep}
        />
        {step === "crop" && (
          <p>
            Aby wykadrować zdjęcie możesz kręcić kółkiem myszy i przesuwać obraz
          </p>
        )}
        {/* <div style={{}}> */}
        {step !== "crop" && (
          <Button onClick={handleSave} disabled={isSaving}>
            {isSaving ? "Zapisywanie..." : "Zapisz"}
          </Button>
        )}
        {step === "crop" && (
          <Button onClick={handleShowCroppedImage}>Zakończ kadrowanie</Button>
        )}
        {/* </div> */}
      </div>

      <div
        id="printable-content"
        style={{
          position: "relative",
          width: pdfWidth,
          height: pdfHeight,
          fontFamily: "DancingScript-Regular, Margarine-Regular, PLZurichItalic",
          backgroundColor: "#ffffff",
          margin: "auto",
        }}
      >
        <InlineEdit
          value={text1}
          setValue={setText1}
          style={{
            fontSize: `${fontSizeText1}px`,
            lineHeight: `${fontSizeText1}px`,
            fontFamily: "DancingScript-Regular",
            zIndex: "12",
            color: "#8aa8d3",
            position: "absolute",
            top: "66px",
            left: "0px",
            right: "0px",
            // width: "200px",
            margin: "auto",
            textAlign: "center",
            transform: "rotate(0deg)",
            // letterSpacing: "0.2rem",
            fontWeight: "bold"
          }}
        />
        <InlineEdit
          value={text2}
          setValue={setText2}
          style={{
            fontSize: `${fontSizeText2}px`,
            fontFamily: "DancingScript-Regular",
            lineHeight: `${fontSizeText2}px`,
            position: "absolute",
            top: "267px",
            right: "0px",
            left: "300px",
            textAlign: "center",
            transform: "rotate(15deg)",
            fontWeight: "600",
            color: "#b7c7da",
            zIndex: "12",
            padding: "0px",
          }}
        />
        <InlineEdit
          value={text3}
          setValue={setText3}
          style={{
            fontSize: `${fontSizeText3}px`,
            fontFamily: "Margarine-Regular",
            lineHeight: `${fontSizeText3}px`,
            position: "absolute",
            top: "250px",
            left: "75px",
            // right: "118px",
            maxWidth: "150px",
            textAlign: "center",
            transform: "rotate(0deg)",
            fontWeight: "400",
            color: "#f2f2f2",
            zIndex: "12",
          }}
        />
        <InlineEdit
          value={text4}
          setValue={setText4}
          style={{
            fontSize: `${fontSizeText4}px`,
            fontFamily: "Margarine-Regular",
            lineHeight: `${fontSizeText4}px`,
            position: "absolute",
            top: "290px",
            left: "75px",
            // right: "0px",
            maxWidth: "150px",
            textAlign: "center",
            transform: "rotate(0deg)",
            fontWeight: "400",
            zIndex: "99",
            color: "#f2f2f2",
          }}
        />
        <InlineEdit
          value={text5}
          setValue={setText5}
          style={{
            fontSize: `${fontSizeText5}px`,
            fontFamily: "Margarine-Regular",
            lineHeight: `${fontSizeText5}px`,
            position: "absolute",
            top: "665px",
            left: "175px",
            // right: "0px",
            maxWidth: "150px",
            textAlign: "center",
            transform: "rotate(0deg)",
            fontWeight: "400",
            zIndex: "99",
            color: "#f2f2f2"
          }}
        />
        <InlineEdit
          value={text6}
          setValue={setText6}
          style={{
            fontSize: `${fontSizeText6}px`,
            fontFamily: "Margarine-Regular",
            lineHeight: `${fontSizeText6}px`,
            position: "absolute",
            top: "651px",
            right: "127px",
            // right: "0px",
            maxWidth: "150px",
            textAlign: "center",
            transform: "rotate(0deg)",
            fontWeight: "400",
            zIndex: "99",
            color: "#f2f2f2"
          }}
        />
        <InlineEdit
          value={text7}
          setValue={setText7}
          style={{
            fontSize: `${fontSizeText7}px`,
            fontFamily: "Margarine-Regular",
            lineHeight: `${fontSizeText7}px`,
            position: "absolute",
            top: "758px",
            right: "68px",
            // right: "0px",
            maxWidth: "150px",
            textAlign: "center",
            transform: "rotate(0deg)",
            fontWeight: "400",
            zIndex: "99",
            color: "#f2f2f2"
          }}
        />

        <InlineEdit
          value={text8}
          setValue={setText8}
          style={{
            fontSize: `${fontSizeText8}px`,
            fontFamily: "PLZurichItalic",
            lineHeight: `${fontSizeText8}px`,
            position: "absolute",
            bottom: "210px",
            left: "205px",
            right: "120px",
            // maxWidth: "850px",
            textAlign: "center",
            transform: "rotate(0deg)",
            fontWeight: "400",
            zIndex: "99",
            color: "#8aa8d3"
          }}
        />

          <InlineEdit
          value={text9}
          setValue={setText9}
          style={{
            fontSize: `${fontSizeText9}px`,
            fontFamily: "PLZurichItalic",
            lineHeight: `${fontSizeText9}px`,
            position: "absolute",
            bottom: "180px",
            left: "205px",
            right: "120px",
            // maxWidth: "850px",
            textAlign: "center",
            transform: "rotate(0deg)",
            fontWeight: "400",
            zIndex: "99",
            color: "#8aa8d3"
          }}
        />

          <InlineEdit
          value={text10}
          setValue={setText10}
          style={{
            fontSize: `${fontSizeText10}px`,
            fontFamily: "PLZurichItalic",
            lineHeight: `${fontSizeText10}px`,
            position: "absolute",
            bottom: "150px",
            left: "205px",
            right: "120px",
            // maxWidth: "850px",
            textAlign: "center",
            transform: "rotate(0deg)",
            fontWeight: "400",
            zIndex: "99",
            color: "#8aa8d3"
          }}
        />

          <InlineEdit
          value={text11}
          setValue={setText11}
          style={{
            fontSize: `${fontSizeText11}px`,
            fontFamily: "PLZurichItalic",
            lineHeight: `${fontSizeText11}px`,
            position: "absolute",
            bottom: "105px",
            right: "230px",
            width: "160px",
            // maxWidth: "150px",
            textAlign: "right",
            transform: "rotate(0deg)",
            fontWeight: "400",
            zIndex: "99",
            color: "#8aa8d3"
          }}
        />

          {/* <InlineEdit
          value={text12}
          setValue={setText12}
          style={{
            fontSize: `${fontSizeText12}px`,
            fontFamily: "Margarine-Regular",
            lineHeight: `${fontSizeText12}px`,
            position: "absolute",
            bottom: "120px",
            left: "160px",
            width: "400px",
            textAlign: "center",
            transform: "rotate(0deg)",
            fontWeight: "400",
            zIndex: "99",
            color: "#6b6968"
          }}
        /> */}
        {/* Step: Crop */}
        {image && step === "crop" && (
          <CropperWrapper
            image={image}
            crop={crop}
            zoom={zoom}
            aspect={455 / 474}
            cropShape={"round"}
            onCropChange={setCrop}
            onZoomChange={setZoom}
            onCropComplete={handleCropComplete}
            style={{
              top: "345px",
              left: "520px",
              height: "474px",
              width: "455px",
              transform: "translateX(-50%)",
              borderRadius: "50%",
            }}
          />
        )}

        {/* Step: View */}
        {croppedImage && step === "view" && (
          <img
            src={croppedImage}
            style={{
              position: "absolute",
              top: "345px",
              left: "520px",
              height: "474px",
              width: "455px",
              transform: "translateX(-50%)",
              borderRadius: "50%",
              zIndex: 2,
            }}
          />
        )}
        {/* 
        <img
          src="/images/Ad1overlay.svg"
          style={{
            position: "absolute",
            zIndex: 5,
            top: '0px',
            left: '0px',
            width: '100%',
            height: '100%'
          }}
        /> */}


        <img
          src="/images/Basnie36png.png"
          style={{ width: "100%", height: "100%", position: 'absolute', top: '0', left: '0', zIndex: '2' }}
        />
      </div>
    </div>
  );
};